import BlockIcon from "@mui/icons-material/Block";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import ErrorPage from "../../ErrorPage";

export type NoDataAvailableForErrorProps = {
  subtitleTranslationKey: string;
};

const NoDataAvailableError = ({
  subtitleTranslationKey: translationKey,
}: NoDataAvailableForErrorProps) => {
  const theme = useTheme();
  const { t } = useTranslation("common");

  const title = t(`error.noDataAvailable.title.${translationKey}`, {
    defaultValue: t("error.noDataAvailable.title"),
  });
  const subtitle = t(`error.noDataFound.subtitle.${translationKey}`) as string;

  return (
    <ErrorPage
      title={title}
      subtitle={subtitle}
      icon={{
        Component: BlockIcon,
        styles: {
          color: theme.tokens.FuelColorGray700,
          height: theme.tokens.FuelSpacing6,
          width: theme.tokens.FuelSpacing6,
        },
      }}
    />
  );
};

export default NoDataAvailableError;
